<template>
  <div class="risk-box">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <el-alert type="warning" :closable="false" style="margin-bottom: 16px">
        注：风控规则由平台保留最终解释权，所有风控内容最终以平台设置的可调范围为准。
      </el-alert>
      <el-form-item label="执行者年龄区间：">
        <el-input disabled :value="ruleForm.ageStart" placeholder="">
          <span slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input disabled :value="ruleForm.ageEnd" placeholder="">
          <span slot="suffix">岁</span>
        </el-input>
      </el-form-item>

      <!-- 自答模式-->
      <template v-if="answerMode === 1">
        <el-row type="flex" justify="start">
          <el-form-item
            label="项目执行人单篇文章："
            prop="monthNumber"
            :rules="[{ required: true, validator: validateMonth }]"
          >
            <el-input
              v-model="ruleForm.monthNumber"
              :disabled="true"
              placeholder=""
            >
              <span slot="suffix">自然月内</span>
            </el-input>
          </el-form-item>
          <span style="line-height: 41px;text-align: center;width: 70px">
            可提交
          </span>
          <el-form-item
            style="margin-left: -220px;"
            prop="monthNumberSubmit"
            :rules="[{ required: true, validator: validateMonth }]"
          >
            <el-input
              v-model="ruleForm.monthNumberSubmit"
              :disabled="!!!rawRespondData.monthNumberIsUpdate"
              placeholder=""
            >
              <span slot="suffix">次</span>
            </el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start">
          <el-form-item
            label="项目执行人单篇文章："
            prop="dayNumber"
            :rules="[{ required: true, validator: validateDay }]"
          >
            <el-input
              ref="formItemInput"
              v-model="ruleForm.dayNumber"
              :disabled="true"
              placeholder=""
            >
              <span slot="suffix">天内</span>
            </el-input>
          </el-form-item>
          <span style="line-height: 41px;text-align: center;width: 70px">
            可提交
          </span>
          <el-form-item
            style="margin-left: -220px;"
            prop="dayNumberSubmit"
            :rules="[{ required: true, validator: validateDay }]"
          >
            <el-input
              v-model="ruleForm.dayNumberSubmit"
              :disabled="!!!rawRespondData.dayNumberIsUpdate"
              placeholder=""
            >
              <span slot="suffix">次</span>
            </el-input>
          </el-form-item>
        </el-row>
      </template>

      <!-- 自答模式-->
    </el-form>
    <template v-if="!isDialog">
      <div class="el-form-item__content" style="margin-left: 220px;">
        <span style="color:#9D9D9D">注：所有修改内容将于次日0:00生效</span>
      </div>
      <div style="display: flex;justify-content: center">
        <el-button
          type="primary"
          class="bts"
          @click="update"
          :disabled="!btnEnabled"
        >
          保存
        </el-button>
        <el-button type="primary" class="bts" @click="showRecordList">
          风控记录
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { makeSure } from '@/Mixin/makeSure';
import { riskControl } from '@/api/ajax';
import createExtend from '../../../components/createExtend';
import digitalSurveyRecord from './digitalSurveyRecord';
import { mapState } from 'vuex';

export default {
  name: 'digitalSurvey',
  mixins: [makeSure],
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      ruleForm: {
        monthNumber: '',
        monthNumberSubmit: '',
        dayNumber: '',
        dayNumberSubmit: ''
      },
      rawRespondData: null,
      canEdit: false,
      validateMonth: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不能为空'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('validateMonth');
          }
          callback();
        }
      },
      validateDay: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不能为空'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('validateMonth');
          }
          callback();
        }
      }
    };
  },
  computed: {
    ...mapState({
      answerMode: state => state.homeProject.answerMode, // 1 自答 2 分享
      projectId: state => state.homeProject.id
    }),
    btnEnabled() {
      // 包含可编辑的部分，保存按钮可用
      const { monthNumberIsUpdate, dayNumberIsUpdate } = this.rawRespondData;
      return [+monthNumberIsUpdate, +dayNumberIsUpdate].includes(1);
    }
  },
  methods: {
    async update() {
      try {
        await this.$refs.ruleForm.validate();
      } catch (e) {
        console.error(e);
        return;
      }

      // 获得 可修改数据 传不可修改字段会报错
      let queryForm = JSON.parse(JSON.stringify(this.ruleForm));
      delete queryForm.ageStart;
      delete queryForm.ageEnd;

      delete queryForm.dayNumberIsUpdate;
      delete queryForm.monthNumberIsUpdate;
      delete queryForm.enableDt;
      delete queryForm.isEnable;
      delete queryForm.id;

      if (+this.ruleForm.dayNumberIsUpdate !== 1) {
        delete queryForm.dayNumber;
        delete queryForm.dayNumberSubmit;
      }
      if (+this.ruleForm.monthNumberIsUpdate !== 1) {
        delete queryForm.monthNumber;
        delete queryForm.monthNumberSubmit;
      }

      riskControl.digitalSurvey
        .update({
          ...queryForm,
          projectId: this.$store.state.homeProject.id,
          id: this.rawRespondData.id
        })
        .then(res => {
          const {
            data: { status, message }
          } = res;
          if (+status === 1) {
            this.$message.success(message);
          } else {
            this.$message.error(message);
          }
        });
    },
    showRecordList() {
      createExtend(digitalSurveyRecord);
    }
  },
  async created() {
    // 查询 风控详情
    const {
      data: { data }
    } = await riskControl.digitalSurvey.detail({
      projectId: this.projectId,
      id: this.obj.id || ''
    });

    // 缓存 原始 响应数据
    this.rawRespondData = data;

    this.ruleForm = data;
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
